// Version: 1.1
import React, { useEffect, useState } from 'react';
import { useAuth } from './auth';
import { authFetch } from './auth';
import ComplianceTile from './ComplianceTile';
import PhishingSection from './PhishingSection';

export default function Compliance({ adminSlug }) {
  const { user } = useAuth();
  // adminSlug is passed when an admin views a specific client's compliance page.
  // For client users, slug comes from their own account.
  const slug = adminSlug || user?.client_slug || '';
  const isAdmin = user?.role === 'admin';

  return (
    <div>
      <div className="page-header">
        <div className="page-title">Compliance</div>
        <div className="page-subtitle">Framework assessments and compliance posture</div>
      </div>
      {slug ? (
        <>
          <ComplianceTile slug={slug} />
          <PhishingSection slug={slug} isAdmin={isAdmin} />
        </>
      ) : (
        <div className="card" style={{ padding: 48, textAlign: 'center', color: 'var(--text-muted)' }}>
          No client account linked.
        </div>
      )}
    </div>
  );
}
